import {__} from "@wordpress/i18n";
import {USER_BEHAVIOR, WOOCOMMERCE} from '@app/config/constants/UserRules';
import {WEBSITE_BEHAVIOR} from '@app/config/constants/WebsiteRules';
import {BROWSER_BEHAVIOR} from '@app/config/constants/BrowserRules';

export const RULES_TYPES = [
	{
		id: 'UserBehavior',
		name: __('User Behavior', 'dxp')
	},
	{
		id: 'BrowserBehavior',
		name: __('Browser Behavior', 'dxp')
	},
	{
		id: 'WebsiteBehavior',
		name: __('Website Behavior', 'dxp')
	},
];

export const DEFAULT_RULES = [
	...USER_BEHAVIOR,
	...WOOCOMMERCE,
	...BROWSER_BEHAVIOR,
	...WEBSITE_BEHAVIOR,
];
